import MainHeader from './components/MainHeader';
import AriaHandler from './components/AriaHandler';
import FocusableHandler from './components/FocusableHandler';
import ScreenReaderHandler from './components/ScreenReaderHandler';

/**
 * Controller class.
 *
 * Standardizes how we hook into event listeners and create components.
 */
class Controller {
	constructor() {
		this.init();

		window.addEventListener('resize', this.resized);
		window.addEventListener('load', this.loaded);
	}

	init() {
		MainHeader.init();
		AriaHandler.init();
		AriaHandler.setAriaHidden();
		FocusableHandler.init({
			focusable: ['.goog-te-gadget', '.block-accordion .block-bellow__top'],
			nonFocusable: [],
		});
		ScreenReaderHandler.init([
			{
				parent: '.block-content-card-column',
				target: '.block-buttons [class^="btn-"]',
				attachOn: 'append',
				setTextFromElement: '.block-content-card-column__content .wp-block-heading',
				setSeparatorText: ': ',
			},
		]);
	}

	resized() {
		MainHeader.resized();
		AriaHandler.setAriaHidden();
	}

	loaded() {
		MainHeader.loaded();
		AriaHandler.setAriaHidden();
		FocusableHandler.setFocusable();
		ScreenReaderHandler.setScreenReader();
	}
}

// Run controller.
new Controller();
